{
  "page": {
    "title": "คลังสินค้า",
    "subtitle": ""
  },
  "tab": {
    "all": "ทั้งหมด",
    "single": "เดี่ยว",
    "bundles": "ชุดสินค้า"
  },
  "type": {
    "single": "เดี่ยว",
    "bundle": "ชุดสินค้า"
  },
  "toolbar": {
    "create": "สร้าง SKU",
    "sync": "ซิงค์ตอนนี้",
    "sync_multi": "ซิงค์หลายรายการ…",
    "sync_all": "",
    "export": "ส่งออก",
    "bulk_edit": "แก้ไขหลายรายการ",
    "import_transfers": "นำเข้าการโอน",
    "reset_defaults": "รีเซ็ตค่าตั้งต้น",
    "more": "เพิ่มเติม",
    "export_csv": "ส่งออก CSV",
    "coming_soon": "{{label}} — เร็วๆ นี้",
    "export_done": "ส่งออก {{count}} รายการแล้ว",
    "export_empty": "ไม่มีข้อมูลที่จะส่งออก",
    "export_failed": "ส่งออกล้มเหลว"
  },
  "filter": {
    "all_marketplaces": "ทุกมาร์เก็ตเพลส",
    "all_statuses": "",
    "search_placeholder": "ค้นหาสินค้า หรือ SKU…",
    "brand_unmapped": "แบรนด์: ยังไม่ระบุแบรนด์"
  },
  "column": {
    "product": "สินค้า",
    "sku": "รหัส SKU",
    "type": "ประเภท",
    "marketplace": "มาร์เก็ตเพลส",
    "allocation": "การจัดสรร",
    "multiplier": "ตัวคูณ",
    "sellable": "ขายได้",
    "fake": "Fake",
    "lock": "ล็อกแมนวล",
    "reserved": "จองแล้ว",
    "bundle_reserve": "จองโดยชุดสินค้า",
    "on_hand": "สต๊อกจริง",
    "last_synced": "ซิงค์ล่าสุด",
    "status": "สถานะ"
  },
  "sort": {
    "sortBy": "เรียงตาม {{column}}",
    "ascending": "เรียงจากน้อยไปมาก",
    "descending": "เรียงจากมากไปน้อย",
    "none": "ไม่ได้เรียง"
  },
  "status": {
    "healthy": "ปกติ",
    "low_stock": "ใกล้หมด",
    "out_of_stock": "หมดสต๊อก",
    "oversold": "ขายเกินสต๊อก"
  },
  "tooltip": {
    "lock": "จำนวนที่ถูกล็อกด้วยตนเองโดยผู้ดำเนินการ"
  },
  "state": {
    "loading_rows": "กำลังโหลดคลังสินค้า…",
    "no_results": "ไม่พบ SKU ที่ตรงกัน",
    "no_results_hint": "ลองล้างตัวกรองหรือสร้าง SKU ใหม่",
    "error": "โหลดคลังสินค้าไม่สำเร็จ กรุณาลองรีเฟรชหน้า",
    "retry": "ลองใหม่",
    "clear_filters": "ล้างตัวกรอง",
    "no_data": "ยังไม่มี SKU"
  },
  "diff": {
    "expected": "คาดหวัง",
    "reported": "ที่รายงาน",
    "diff": "ส่วนต่าง",
    "variance": "ค่าเบี่ยงเบน"
  },
  "ratio": {
    "shopee": "% Shopee",
    "lazada": "% Lazada",
    "tiktok": "% TikTok",
    "import": "นำเข้าสัดส่วน",
    "sync_notice": "การเปลี่ยนสัดส่วนจะมีผลในรอบซิงค์สต็อกถัดไป ไม่ใช่ทันที",
    "search_placeholder": "ค้นหา SKU แบบตรงตัว…",
    "search_not_found": "ไม่พบ SKU ที่ตรงกับ “{{sku}}”",
    "page": {
      "title": "สัดส่วนสต๊อก",
      "subtitle": "{{count}} SKU · แบ่ง Shopee / Lazada / TikTok"
    },
    "column": {
      "sku": "รหัส SKU",
      "sum": "รวม",
      "actions": "การทำงาน"
    },
    "action": {
      "save": "บันทึก",
      "reset": "คืนค่าเริ่มต้น"
    },
    "state": {
      "empty": "ยังไม่มี SKU ในแคตตาล็อก"
    },
    "error": {
      "sum": "ratio.error.sum"
    },
    "toast": {
      "saved": "บันทึกสัดส่วนแล้ว",
      "save_error": "ไม่สามารถบันทึกสัดส่วนได้ กรุณาลองใหม่",
      "reverted": "คืนค่าเป็นสัดส่วนเริ่มต้น 40/40/20 แล้ว",
      "import_soon": "การนำเข้าสัดส่วนจะมาในรุ่นถัดไป"
    }
  },
  "empty": {
    "no_skus_match": "",
    "try_clearing": ""
  },
  "bulk": {
    "skus_selected": "",
    "reset_done": "รีเซ็ต {{count}} แถวเป็นค่าตั้งต้นแล้ว",
    "reset_error": "รีเซ็ตไม่สำเร็จ — กรุณาลองใหม่อีกครั้ง",
    "edit": {
      "title": "แก้ไขหลายรายการ",
      "subtitle": "กำลังแก้ไข {{count}} รายการ",
      "field_multiplier": "ตัวคูณ",
      "field_fake": "Fake",
      "field_lock": "ล็อคแบบ Manual",
      "placeholder_unchanged": "เว้นว่างเพื่อคงค่าเดิม",
      "at_least_one": "กรอกอย่างน้อยหนึ่งช่อง",
      "invalid_multiplier": "ตัวคูณต้องเป็นตัวเลขระหว่าง 0 ถึง 1 (ใช้ '.')",
      "invalid_integer": "ต้องเป็นจำนวนเต็มตั้งแต่ 0 ขึ้นไป",
      "action_apply": "นำไปใช้กับที่เลือก",
      "action_applying": "กำลังนำไปใช้…",
      "action_cancel": "ยกเลิก",
      "success": "อัปเดต {{count}} รายการแล้ว"
    },
    "sync": "ซิงก์ไปมาร์เก็ตเพลส",
    "sync_done": "ส่งสต็อก {{count}} แถวไปมาร์เก็ตเพลสแล้ว",
    "sync_partial": "ส่งไม่สำเร็จ {{failed}} จาก {{count}} แถว — ดูประวัติการส่ง",
    "sync_error": "ซิงก์ไม่สำเร็จ — กรุณาลองใหม่อีกครั้ง"
  },
  "modal": {
    "create_sku_bundle": {
      "title": "สร้าง SKU/บันเดิล",
      "is_bundle": "เป็นบันเดิล",
      "field_name": "ชื่อสินค้า",
      "placeholder_name": "เช่น Travel Mug 400ml",
      "field_code": "รหัส SKU / บันเดิล",
      "placeholder_code": "เช่น 0009999",
      "hint": "สร้าง SKU หนึ่งรายการพร้อมสต็อกแยกตามแต่ละมาร์เก็ตเพลส (Shopee, Lazada, TikTok)",
      "components_legend": "ส่วนประกอบ",
      "components_empty_hint": "ค้นหาและเพิ่มสินค้าหลัก",
      "picker_placeholder": "ค้นหาสินค้า…",
      "picker_searching": "กำลังค้นหา…",
      "picker_no_results": "ไม่พบสินค้า",
      "multiplier": "ตัวคูณ",
      "action_remove_component": "ลบส่วนประกอบ",
      "action_create": "สร้าง",
      "action_cancel": "ยกเลิก",
      "field_ap_name": "แบรนด์ (AP)",
      "placeholder_ap_name": "เช่น TONG GARDEN — เว้นว่างได้หากไม่ทราบ"
    },
    "edit_sku": {
      "title": "แก้ไข SKU",
      "field_name": "ชื่อสินค้า",
      "action_save": "บันทึก",
      "action_saving": "กำลังบันทึก…",
      "action_cancel": "ยกเลิก",
      "success": "อัปเดต SKU {{sku}} แล้ว"
    }
  },
  "confirm": {
    "delete_sku": {
      "title": "ลบ SKU",
      "description": "การกระทำนี้ไม่สามารถย้อนกลับได้ พิมพ์ DELETE เพื่อยืนยัน",
      "type_to_confirm": "พิมพ์ DELETE เพื่อยืนยัน",
      "action_delete": "ลบ",
      "action_cancel": "ยกเลิก",
      "success": "ลบ SKU {{sku}} แล้ว"
    },
    "reset_row": {
      "title": "รีเซ็ตแถวนี้เป็นค่าตั้งต้น?",
      "description": "การดำเนินการนี้จะรีเซ็ตตัวคูณ fake และล็อกแมนวลของ {{sku}} / {{mkp}} กลับเป็นค่าตั้งต้น",
      "action_reset": "รีเซ็ต",
      "action_cancel": "ยกเลิก"
    }
  },
  "action": {
    "delete_sku": "ลบ SKU",
    "edit_product": "แก้ไขสินค้า",
    "transfer": "โอนสต็อก",
    "audit": "ประวัติการตรวจสอบ",
    "calculate": "คำนวณใหม่",
    "calculate_done": "คำนวณ {{sku}} ใหม่แล้ว",
    "calculate_error": "คำนวณใหม่ล้มเหลว — กรุณาลองใหม่อีกครั้ง",
    "sync": "ซิงค์ไปยังมาร์เก็ตเพลส",
    "check_sellername": "ตรวจสอบชื่อผู้ขาย",
    "reset_defaults": "รีเซ็ตแถวนี้เป็นค่าตั้งต้น",
    "reset_defaults_done": "รีเซ็ต {{sku}} เป็นค่าตั้งต้นแล้ว",
    "set_default": "คืนค่าเริ่มต้น",
    "set_default_aria": "คืนค่า {{field}} เป็นค่าเริ่มต้น"
  },
  "audit": {
    "drawer_title": "ประวัติการตรวจสอบ",
    "filter_all": "ทุกฟิลด์",
    "filter_notable": "สำคัญ+",
    "export_csv": "ส่งออก CSV",
    "empty": "ยังไม่มีประวัติการตรวจสอบ",
    "actor_system": "ระบบ",
    "sev_info": "INFO",
    "sev_notable": "NOTABLE",
    "sev_high": "HIGH",
    "error": "โหลดประวัติการตรวจสอบไม่สำเร็จ กรุณาลองใหม่",
    "retry": "ลองใหม่",
    "time_utc_suffix": "({{utc}} UTC)",
    "order_context": "คำสั่งซื้อ {{id}}",
    "view_in_log": "ดูใน Audit Log"
  },
  "transfer": {
    "title": "โอนสต๊อก",
    "route": "เส้นทาง",
    "qty": "จำนวน",
    "from": "จาก",
    "to": "ไปยัง",
    "confirm": "ยืนยันการโอน",
    "cancel": "ยกเลิก",
    "preview_onhand": "สต๊อกจริง {{mkp}}",
    "err_same": "ต้นทางและปลายทางต้องไม่เหมือนกัน",
    "err_qty": "จำนวนต้องมากกว่า 0",
    "warn_oversold": "ต้นทางจะเกินยอด",
    "toast_done": "โอน {{qty}} จาก {{from}} ไปยัง {{to}} สำเร็จ",
    "toast_error": "การโอนล้มเหลว กรุณาลองใหม่",
    "err_insufficient": "สต็อกไม่เพียงพอ — อาจมีการดำเนินการอื่นลดจำนวนสต็อกที่มีอยู่"
  },
  "sync": {
    "toast_done": "ซิงค์ {{sku}} ไปยัง {{mkp}} แล้ว",
    "toast_failed": "ซิงค์ {{sku}} ล้มเหลว: {{message}}",
    "toast_error": "ไม่สามารถซิงค์ {{sku}} ได้ กรุณาลองใหม่",
    "rate_limited": "ถูกจำกัดอัตรา — กรุณาลองใหม่ในอีกสักครู่",
    "not_available": "ยังไม่เปิดให้ส่งสต็อกไปยังมาร์เก็ตเพลส"
  },
  "sync_multi": {
    "title": "ซิงค์หลายรายการ",
    "subtitle": "วาง SKU เพื่อส่งการจัดสรรไปยังมาร์เก็ตเพลสพร้อมกันทีเดียว",
    "marketplace": "มาร์เก็ตเพลส",
    "skus_label": "รายการ SKU",
    "skus_count": "{{count}} SKU",
    "skus_placeholder": "วาง SKU หนึ่งรายการต่อบรรทัด…",
    "submit": "ซิงค์ {{count}} SKU",
    "submitting": "กำลังซิงค์…",
    "close": "ปิด",
    "col_sku": "SKU",
    "col_result": "ผลลัพธ์",
    "col_message": "ข้อความ",
    "ok": "สำเร็จ",
    "failed": "ล้มเหลว",
    "toast_done": "ซิงค์ {{count}} SKU แล้ว",
    "toast_partial": "ซิงค์สำเร็จ {{ok}} รายการ, ล้มเหลว {{failed}} รายการ",
    "toast_error": "ซิงค์หลายรายการล้มเหลว กรุณาลองใหม่"
  },
  "seller_ref": {
    "title": "ตรวจสอบชื่อผู้ขาย",
    "subtitle": "{{sku}} · {{mkp}}",
    "col_seller_id": "รหัสผู้ขาย",
    "col_product_id": "รหัสสินค้า",
    "col_seller_name": "ชื่อผู้ขาย",
    "loading": "กำลังค้นหาข้อมูลรายการขาย…",
    "empty": "ไม่พบการแมป SKU นี้บน {{mkp}}",
    "error": "ค้นหาชื่อผู้ขายไม่สำเร็จ กรุณาลองใหม่",
    "not_available": "การเชื่อมต่อมาร์เก็ตเพลสยังไม่พร้อมใช้งาน กรุณากลับมาตรวจสอบอีกครั้งหลังเปิดใช้งานการเชื่อมต่อโดยตรง",
    "retry": "ลองใหม่",
    "close": "ปิด"
  },
  "remark": {
    "label": "หมายเหตุ (ไม่บังคับ)",
    "placeholder": "เพิ่มหมายเหตุสำหรับประวัติการตรวจสอบ…"
  },
  "bundle": {
    "toolbar": {
      "create": "สร้างชุดสินค้า"
    },
    "column": {
      "code": "รหัสชุดสินค้า",
      "name": "ชื่อสินค้า",
      "components": "ส่วนประกอบ",
      "actions": "การดำเนินการ"
    },
    "action": {
      "edit": "แก้ไข",
      "delete": "ลบ",
      "recompute": "คำนวณใหม่"
    },
    "state": {
      "no_data": "ยังไม่มีชุดสินค้า",
      "no_data_hint": "สร้างชุดสินค้าเพื่อจับคู่ SKU หลักเข้ากับสินค้าบนมาร์เก็ตเพลส",
      "error": "ไม่สามารถโหลดชุดสินค้าได้",
      "retry": "ลองอีกครั้ง"
    },
    "modal": {
      "edit": {
        "title": "แก้ไขชุดสินค้า"
      },
      "field_code": "รหัสชุดสินค้า",
      "field_name": "ชื่อสินค้า",
      "placeholder_name": "ชื่อสินค้าบนมาร์เก็ตเพลส",
      "components_legend": "ส่วนประกอบ",
      "placeholder_multiplicity": "จำนวน",
      "action_remove_component": "ลบส่วนประกอบ",
      "sellable_legend": "จำนวนที่ขายได้ที่คำนวณตามมาร์เก็ตเพลส",
      "sellable_loading": "กำลังคำนวณจำนวนที่ขายได้…",
      "sellable_empty": "ยังไม่มีจำนวนที่ขายได้ที่คำนวณไว้",
      "action_cancel": "ยกเลิก",
      "action_save": "บันทึก",
      "action_saving": "กำลังบันทึก…"
    },
    "confirm": {
      "delete": {
        "title": "ลบชุดสินค้า",
        "description": "การดำเนินการนี้จะลบชุดสินค้า \"{{code}}\" อย่างถาวร และไม่สามารถกู้คืนได้",
        "type_to_confirm": "พิมพ์ DELETE เพื่อยืนยัน",
        "action_delete": "ลบ",
        "action_cancel": "ยกเลิก",
        "success": "ลบชุดสินค้า {{code}} แล้ว"
      }
    },
    "toast": {
      "created": "สร้างชุดสินค้า {{code}} แล้ว",
      "updated": "อัปเดตชุดสินค้า {{code}} แล้ว",
      "recomputed": "คำนวณ {{code}} ใหม่แล้ว ({{mkp}})",
      "recompute_error": "ไม่สามารถคำนวณ {{code}} ใหม่ได้"
    }
  },
  "synced": {
    "never": "—",
    "pending": "รอส่ง · ซิงค์ล่าสุด {{rel}} ⚠",
    "failed": "ล้มเหลว {{rel}} ✖",
    "no_listing": "— ไม่มีประกาศขาย"
  },
  "row": {
    "sync_now": "ซิงค์ตอนนี้",
    "push_history": "ประวัติการส่งสต๊อก"
  },
  "push": {
    "paused": {
      "title": "การส่งสต๊อกไปยัง {{mkp}} ถูกหยุดชั่วคราว",
      "body": "{{reason}} ตรวจสอบแถวที่ถูกระงับแล้วส่ง หรือแก้สต็อกแล้วกดกลับมาส่งสต็อกต่อ",
      "truncated": "แสดง {{shown}} จาก {{total}} แถวที่ถูกระงับ — ระบบจะไม่กลับมาส่งอัตโนมัติหลังส่งชุดนี้ กรุณาตรวจสอบที่เหลือแล้วกดกลับมาส่งสต็อกต่อ",
      "body_no_reason": "ตรวจสอบแถวที่ถูกระงับแล้วส่ง หรือแก้สต็อกแล้วกดกลับมาส่งสต็อกต่อ"
    },
    "review": "ตรวจสอบ",
    "resume": "กลับมาส่งสต็อกต่อ",
    "sent_admin_resume": "ส่งสต็อกแล้ว ผู้ดูแลระบบต้องเปิดการอัปเดตสต็อกอัตโนมัติอีกครั้ง",
    "history": {
      "title": "ประวัติการส่งสต๊อก — {{sku}} · {{mkp}}",
      "sent": "ส่งแล้ว {{qty}} ({{alloc}} + จอง {{reserved}})",
      "empty": "ยังไม่มีประวัติการส่งสต๊อก",
      "failed": "ล้มเหลว: {{error}}",
      "result": {
        "shadow": "โหมดเงา: บันทึกแต่ไม่ส่ง",
        "no_listing": "ไม่มีประกาศขายในมาร์เก็ตเพลส",
        "held_multi_warehouse": "ระงับ: ร้านมีหลายคลัง",
        "held_breaker": "ระงับโดยเซอร์กิตเบรกเกอร์",
        "disabled": "ปิดการส่งสต็อก"
      },
      "reason": {
        "loop": "ตามรอบเวลา",
        "fast_path": "ทันที (สต็อกเหลือ 0)",
        "sync": "ซิงค์ด้วยตนเอง",
        "sync_multi": "ซิงค์หลายรายการ",
        "drift": "ส่งซ้ำเพราะยอดไม่ตรง",
        "resume": "กลับมาส่งต่อ"
      }
    }
  },
  "unmapped": {
    "title": "SKU ที่ยังไม่ระบุแบรนด์",
    "subtitle": "{{count}} SKU ที่ยังไม่ระบุแบรนด์",
    "caption": "{{n}} SKU — ส่งรายการนี้ให้ฝ่ายขาย แล้วอัปโหลดไฟล์ CSV แบรนด์อีกครั้ง",
    "copy": "คัดลอกรายการ",
    "copied": "คัดลอก {{n}} SKU แล้ว",
    "copy_failed": "คัดลอกรายการไม่สำเร็จ — กรุณาคัดลอกด้วยตนเอง",
    "empty": "ทุก SKU ระบุแบรนด์แล้ว"
  },
  "brands": {
    "title": "แบรนด์ของ SKU",
    "subtitle": "อัปโหลดไฟล์แบรนด์จากฝ่ายขายเป็น CSV ระบบจะอัปเดตเฉพาะคอลัมน์แบรนด์ SKU ที่ไม่พบจะแสดงเป็นรายการ ไม่สร้างใหม่",
    "upload_title": "ไฟล์ CSV แบรนด์",
    "header_label": "หัวคอลัมน์ที่ต้องมี",
    "copy": "คัดลอก",
    "copied": "คัดลอกแล้ว",
    "copy_failed": "คัดลอกไม่สำเร็จ — กรุณาคัดลอกด้วยตนเอง",
    "file_label": "ไฟล์ CSV",
    "upload": "อัปโหลด",
    "uploading": "กำลังอัปโหลด…",
    "updated": "อัปเดตแล้ว",
    "skipped": "ข้าม",
    "unknown_count": "SKU ที่ไม่พบ",
    "unknown_capped": "แสดง {{shown}} รายการแรกจาก {{total}}",
    "copy_unknown": "คัดลอก SKU ที่ไม่พบ",
    "last_upload": "อัปโหลดล่าสุด: {{who}} · {{when}} · อัปเดต {{updated}} · ไม่พบ {{unknown}}",
    "no_upload": "ยังไม่เคยอัปโหลด",
    "failed": "อัปโหลดไม่สำเร็จ: {{reason}}",
    "error_line": "บรรทัดที่ {{line}}",
    "view_unmapped": "ดู SKU ที่ยังไม่ระบุแบรนด์ →"
  }
}
